import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import * as _ from "lodash";

export class CustomModalContext {
  groupData;
  allGroups;
  isAddingNewCategory;
}

@Component({
  selector: "edit-group-modal",
  templateUrl: "./edit-group-modal.component.html",
  styleUrls: ["./edit-group-modal.component.scss"],
})
export class EditGroupModalComponent implements OnInit {
  isDefault;
  categoryName;
  newDefaultCategory;
  hasError;
  previousDisplayAlias;
  hasDuplicateGroupName;
  hasBlankNameError;

  constructor(
    public dialogRef: MatDialogRef<EditGroupModalComponent>,
    @Inject(MAT_DIALOG_DATA) public context: CustomModalContext
  ) {}

  ngOnInit() {
    this.isDefault = this.context.groupData.isDefault;
    this.previousDisplayAlias = this.context.groupData.displayAlias;
    this.hasBlankNameError = this.context.groupData.displayAlias == "";
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  update() {
    if (
      !this.isDefault &&
      this.context.groupData.isDefault &&
      !this.newDefaultCategory
    ) {
      // if the group was a default group before and the user has unselected that box but hasn't
      // chosen a new default group, show an error
      this.hasError = true;
    } else {
      this.hasError = false;
      this.dialogRef.close({
        categoryName: this.categoryName,
        previousDisplayAlias: this.previousDisplayAlias,
        categoryId: this.context.groupData.id,
        isDefault: this.isDefault,
        newDefaultCategoryId: this.newDefaultCategory,
      });
    }
  }

  textAreaUpdated(value) {
    this.categoryName = value;
    this.hasDuplicateGroupName =
      _.filter(this.context.allGroups, { displayAlias: value }).length > 0 &&
      value != this.previousDisplayAlias;
    this.hasBlankNameError = value == "";
  }

  selectNewDefaultCategory() {
    // clear the error that might be there if they tried to submit a new default category before without selecting from the dropdown
    this.hasError = false;
  }

  checkForError() {
    return this.hasBlankNameError || this.hasDuplicateGroupName;
  }
}
